<template lang="pug">
.view-task
  // Navbar panel
  ui-navbar-panel.mb-20(:backLink="getBackLink()", backLinkText="К списку")
    //- template(slot="back-addon")
      .control(v-if="user.isSupport && task.platform"): b-button.is-rounded(@click="routeToPlatformTasks") {{ task.platform.name }}

    template(slot="filters")
      //-b-field.mb-0(v-if="user.isSupport && task.platform" has-addon)
        b-tooltip.control(label="Список задач платформы")
          b-button.is-rounded(icon-left="cube" @click="routeToPlatformTasks") {{ task.platform.name }}
        b-tooltip.control(label="Сайт платформы")
          b-button.is-rounded(tag="a" :href="task.platform.getUrl()" target="_blank" icon-left="arrow-top-right-thick")
      span {{ panelTitle }}

    template(v-if="editMode")
      b-button.mr-10(@click="toggleEdit") Отменить
      b-button.is-primary(:disabled="isSaveDisabled", @click="save", icon-left="check") Сохранить

    .is-pulled-right(v-else)
      b-button.is-link(
        v-if="user.isSupport && user.id != task.executor_id && !task.is_team_task",
        icon-left="target",
        @click="setExecutorToMe"
      ) Взять задачу себе

      b-button.is-warning.ml-5(
        v-if="reopenTaskStatus && !task.is_team_task",
        @click="saveTaskStatus(reopenTaskStatus)",
        icon-left="progress-upload"
      ) Заново открыть тикет

      template(v-if="user.isSupport && !task.is_team_task")
        b-button.is-primary.ml-5(@click="toggleEdit", icon-left="pencil") Изменить

  // Content
  .container(v-if="!task.$state.loading && !task.is_team_task")
    // Form (Edit mode)
    form-component(
      v-if="editMode",
      v-model="task",
      form="task-form",
      ref="form",
      @afterSave="toggleEdit",
      @afterCreate="routeToTask"
    )

    // Vies
    template(v-else)
      // Title
      .content
        h1
          span.has-text-grey-light \#{{ this.task.id }} &nbsp;
          | {{ this.task.$.title }}
      .columns
        // Контент
        .column.is-8
          .box
            .content(v-html="markdownToHtml(task.$.body)")
            ui-files(:files="task.files")

          // Комментарии
          task-messages(:task="task")

          // Изменение статуса
          //- .box.mb-20.has-background-light(v-if="allowTaskStatuses"): .buttons
            b-button.is-light(disabled): small Новый статус:
            b-button(v-for="status in allowTaskStatuses" :key="status.id" @click="saveTaskStatus(status)")
              task-status(:status="status")

        // Панель справа
        .column.is-4
          .box.is-sticky.has-background-light
            b-field(v-if="user.isSupport && task.platform", label="Платформа")
              platform-label(:platform="task.platform", with-priority, with-link, is-large)

            b-field(v-if="user.isSupport && task.platform", label="Сервер")
              span(v-if="task.platform.server")
                b-tooltip(v-if="task.platform.isActiveServer", :label="task.platform.server.status_label")
                  b-icon(icon="check", type="is-success")
                b-tooltip(v-else, :label="task.platform.server.status_label")
                  b-icon(icon="close", type="is-danger")
                | {{ task.platform.server.name }}
              span(v-else)
                | Не указан

            b-field(label="Статус", v-if="task.status")
              b-button.is-unhover.is-white
                task-status(:status="task.status")

            b-field(label="Тип", v-if="task.label")
              ui-label.is-unhover(:label="task.label", button)

            b-field(label="Метки", v-if="task.tags.length && user.isSupport")
              div.tags
                span(v-for="tag in task.tags" :class="'mr-1 tag ' + tag.color")
                  | {{ tag.name }}

            b-field(v-if="user.isSupport && task.executor", label="Ответственный"): b-button.is-unhover.is-white
              user-name(:user="task.executor", icon="target-account")

            b-field(v-if="task.author", label="Автор"): b-button.is-unhover.is-white
              user-name(:user="task.author")

            b-field(label="Дата создания"): div
              b-button.is-unhover.is-white.mr-10.mb-10
                b-icon(icon="calendar")
                span {{ task.created_at | dateFormat }}
              b-button.is-unhover.is-white.is-white.has-text-grey: small {{ task.created_at | dateToNow(true) }}

            b-field(v-if="task.deadline_at", label="Дедлайн"): div
              b-button.is-unhover.is-white.mr-10.mb-10
                b-icon(icon="calendar")
                span {{ task.deadline_at | dateFormat('date') }}
              b-button.is-unhover.is-white.is-white.has-text-grey: small {{ task.deadline_at | dateToNow(true) }}

            template(v-if="user.isSupport && task.is_team")
              b-icon(icon="wrench")
              | Тикет в Задачах

            .box.has-background-warning(v-if="user.isSupport && task.support_comment")
              .content(v-html="markdownToHtml(task.support_comment)")

  .container(v-if="!task.$state.loading && task.is_team_task")
    // Form (Edit mode)
    form-component(
      v-if="editMode",
      v-model="task",
      form="task-form",
      ref="form",
      @afterSave="toggleEdit",
      @afterCreate="routeToTask"
    )

    // Vies
    template(v-else)
      // Title
      .content
        h1
          span.has-text-grey-light Задача \#{{ this.task.id }} &nbsp;
          | {{ this.task.$.title }}
      .columns
        // Контент
        .column.is-8
          .box
            .content(v-html="markdownToHtml(task.$.body)")
            ui-files(:files="task.files")

        // Панель справа
        .column.is-4
          .box.is-sticky.has-background-light
            b-field(v-if="user.isSupport && task.executor", label="Ответственный"): b-button.is-unhover.is-white
              user-name(:user="task.executor", icon="target-account")

            b-field(v-if="task.author", label="Автор"): b-button.is-unhover.is-white
              user-name(:user="task.author")

            b-field(v-if="task.team_status", label="Статус")
              span {{ task.team_status_label }}

            b-field(label="Дата создания"): div
              b-button.is-unhover.is-white.mr-10.mb-10
                b-icon(icon="calendar")
                span {{ task.created_at | dateFormat }}
              b-button.is-unhover.is-white.is-white.has-text-grey: small {{ task.created_at | dateToNow(true) }}
</template>

<script>
import Task from '@/models/Task';
import TaskStatus from '@/models/TaskStatus';
import BButton from 'buefy/src/components/button/Button';
import { markdownToHtml } from '@/helpers/string';
import BField from 'buefy/src/components/field/Field';
import BIcon from 'buefy/src/components/icon/Icon';
import {ToastProgrammatic as Toast} from 'buefy';

import { mapGetters } from 'vuex';

export default {
  name: 'view-task',

  components: { BIcon, BField, BButton },

  data: () => ({
    task: new Task(),
    statuses: TaskStatus.collection(),
    isSaveDisabled: false,
  }),

  computed: {
    ...mapGetters(['user']),
    panelTitle() {
      return this.task.$isNew ? 'Новый тикет' : '';
    },
    editMode() {
      return !this.$route.params.id || this.$route.name === 'editTask';
    },

    taskStatus() {
      return this.task.id ? this.task.status : null;
    },

    allowTaskStatuses() {
      if (this.user.isSupport) {
        return this.statuses.items.filter(
          ({ id, type }) => id !== this.task.status_id && type !== 'reopen' && type !== 'new'
        );
      }
      return false;
    },

    reopenTaskStatus() {
      if (this.taskStatus && !this.taskStatus.isActive) {
        return this.statuses.find('type', 'reopen');
      }

      return false;
    },
  },

  watch: {
    $route() {
      this.loadState();
      // обрабатываем изменение параметров маршрута...
    },
  },

  methods: {
    markdownToHtml,

    getBackLink() {
      return this.$route.query.from ? { name: 'helpdesk', query: { tasks: 1 } }: 'helpdesk';
    },

    showMessage(message) {
      Toast.open({
        type: 'is-danger',
        duration: 4000,
        message: message,
        queue: false,
      });
      setTimeout(() => {
        this.isSaveDisabled = false;
      }, 1000);
    },

    save() {
      this.isSaveDisabled = true;

      if (this.task.title.trim() === '') {
        this.showMessage('Не указана тема');
        return;
      } else if (this.task.body.trim() === '') {
        this.showMessage('Не указано сообщение');
        return;
      }

      this.$refs.form.save();

      setTimeout(() => {
        this.isSaveDisabled = false;
      }, 5000);
    },

    loadState() {
      if (this.$route.params.id) {
        this.task.$find(+this.$route.params.id, {
          include: 'status,label,author,executor,platform.label,platform.server,files,tags',
        });
        this.statuses.$fetch();
      }
    },

    toggleEdit() {
      let name = 'helpdesk';
      let params = {};
      if (this.$route.params.id) {
        name = this.editMode ? 'task' : 'editTask';
        params.id = this.$route.params.id;
      }
      this.$router.push({ name, params });
    },

    routeToTask({ id }) {
      this.$router.replace({ name: 'task', params: { id } });
    },

    saveTaskStatus(status) {
      this.task.status_id = status.id;
      this.task.status = status;
      this.task.$save();
    },

    setExecutorToMe() {
      this.task.executor_id = this.user.id;
      this.task.executor = this.user;
      this.task.$save();
    },
  },

  created() {
    this.loadState();
  },
};
</script>
